
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 2214","d":"M13.914 11.385a2.677 2.677 0 00.362-.282 2.733 2.733 0 00.658-1.918 3.227 3.227 0 00-3.313-3.207H8.414v12.045h3.639a3.6 3.6 0 001.861-6.638m-3.886-.517V7.594h1.593a1.633 1.633 0 011.7 1.6 1.652 1.652 0 01-1.319 1.67zM13.97 14.4a1.951 1.951 0 01-1.933 2.009h-2.009v-3.927h2.212a1.84 1.84 0 011.73 1.918","fill":"currentColor"}})])
          )
        }
      }
    